import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SEOContentSection() {
  return <section className="py-16 bg-white border-t border-gray-200" data-id="element-310">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
        <div className="prose prose-lg prose-navy max-w-none" data-id="element-312">
          <h2 className="text-3xl font-bold text-navy mb-6 text-center" data-id="element-313">
            Why Choose an Online Degree?
          </h2>

          <p className="text-gray-600 mb-8 text-center" data-id="element-314">
            Online education has transformed how adults achieve their academic
            and career goals. With flexible scheduling, lower overall costs, and
            the same rigorous curriculum as on-campus programs, earning your
            degree online is a smart investment in your future.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-315">
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-316">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-317">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-318" />
                Flexibility & Convenience
              </h3>
              <p className="text-sm text-gray-600" data-id="element-319">
                Study when and where it works for you. Online programs are
                designed for working professionals, allowing you to balance
                education with career and family responsibilities.
              </p>
            </div>
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-320">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-321">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-322" />
                Career Advancement
              </h3>
              <p className="text-sm text-gray-600" data-id="element-323">
                Employers increasingly value online degrees from accredited
                institutions. Gain the skills needed for promotions or career
                changes without leaving your current job.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-324">
            How Our Matching Service Works
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-325">
            Finding the right school can be overwhelming. We simplify the
            process by connecting you with accredited institutions that match
            your specific needs:
          </p>

          <ol className="space-y-4 mb-8 text-gray-600" data-id="element-326">
            <li className="flex items-start" data-id="element-327">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-328">
                1
              </span>
              <div data-id="element-329">
                <strong className="text-navy block" data-id="element-330">
                  Tell us about your goals
                </strong>
                Complete our short form to share your area of interest, current
                education level, and contact information.
              </div>
            </li>
            <li className="flex items-start" data-id="element-331">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-332">
                2
              </span>
              <div data-id="element-333">
                <strong className="text-navy block" data-id="element-334">
                  Get matched instantly
                </strong>
                Our system filters through hundreds of accredited programs to
                find the ones that align with your criteria.
              </div>
            </li>
            <li className="flex items-start" data-id="element-335">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-336">
                3
              </span>
              <div data-id="element-337">
                <strong className="text-navy block" data-id="element-338">Compare and enroll</strong>
                Receive information directly from the schools, compare your
                options, and take the next step toward your degree.
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>;
}